import type { IconProps } from '../icons';

import type { ReactNode } from 'react';

import clsx from 'clsx';
import NavLink from 'next/link';

import { link, statusIcon } from './styles';
import { Icon } from '../icons';

type LinkProps = {
  hasIcon?: boolean;
  children: ReactNode;
  href: string;
  color?: 'primary' | 'secondary';
  icon?: IconProps;
  iconPosition?: 'left' | 'right';
  destructive?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  className?: string;
  key?: string;
};

const Link = ({
  hasIcon,
  href,
  icon,
  className = '',
  children,
  ...rest
}: LinkProps) => {
  const props = {
    ...rest,
    className,
    color: rest.color
  };

  return (
    <NavLink href={href} className={link(props)}>
      {hasIcon && icon && (
        <Icon {...icon} className={clsx(icon.className, statusIcon)} />
      )}
      {children}
    </NavLink>
  );
};

const ButtonLink = ({ className, children, ...rest }: LinkProps) => (
  <Link
    className={clsx(
      className,
      'px-3.5 py-2 w-fit border border-solid border-gray-300 text-sm font-semibold',
      'shadow-sm'
    )}
    {...rest}
  >
    {children}
  </Link>
);

export { ButtonLink, Link };
export type { LinkProps };
